import "@mantine/core/styles.css"
import "@mantine/dates/styles.css"
import "@mantine/notifications/styles.css"
import "@mantine/charts/styles.css"
import "@mantine/dropzone/styles.css"
import "mantine-react-table/styles.css"
import "./mantine-react-table-overrides.css"

import { ClerkProvider } from "@clerk/clerk-react"
import { useMantineColorScheme } from "@mantine/core"
import { QueryClientProvider } from "@tanstack/react-query"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import { ConfigCatProvider } from "configcat-react"
import { RouterProvider } from "react-router-dom"

import { CLERK_THEMES } from "@costory/front/assets/theme/clerk"
import { queryClient } from "@costory/front/lib/queryClient"
import { runtimeConfig } from "@costory/front/lib/runtimeConfig"
import { router } from "@costory/front/pages/router"

import "./reset.css"

const CLERK_PUBLISHABLE_KEY = runtimeConfig.VITE_CLERK_PUBLISHABLE_KEY
const FFKEY = runtimeConfig.VITE_CONFIG_CAT_KEY

if (!CLERK_PUBLISHABLE_KEY) {
  throw new Error("Missing Clerk Publishable Key")
}

function App() {
  const { colorScheme } = useMantineColorScheme()
  return (
    <ClerkProvider
      appearance={CLERK_THEMES[colorScheme === "dark" ? "dark" : "light"]}
      publishableKey={CLERK_PUBLISHABLE_KEY}
      afterSignOutUrl="/"
      signUpUrl="/sign-up"
      localization={{
        unstable__errors: {
          not_allowed_access:
            "Personal email accounts are not allowed, use your company email instead",
        },
      }}
    >
      <QueryClientProvider client={queryClient}>
        <ConfigCatProvider sdkKey={FFKEY}>
          <RouterProvider router={router} />
          <ReactQueryDevtools />
        </ConfigCatProvider>
      </QueryClientProvider>
    </ClerkProvider>
  )
}

export default App
